import { Moment } from "moment";

export default class Declaracao implements IDeclaracao {
  public criadoEm!: Moment;
  public dataBase!: Moment;
  public relatorio1!: IRelatorio<RelatorioCustodia>;
  public relatorio2!: IRelatorio<RelatorioDivida>;
  public relatorio3!: IRelatorio<RelatorioRendimentos>;
  public relatorio4!: IRelatorio<RelatorioRendimentos>;
  public relatorio5!: IRelatorio<RelatorioRendaVariavel>;

  constructor(param: IDeclaracao) {
    Object.assign(this, param);
  }
}

interface IDeclaracao {
  criadoEm: Moment;
  dataBase: Moment;
  relatorio1: IRelatorio<RelatorioCustodia>;
  relatorio2: IRelatorio<RelatorioDivida>;
  relatorio3: IRelatorio<RelatorioRendimentos>;
  relatorio4: IRelatorio<RelatorioRendimentos>;
  relatorio5: IRelatorio<RelatorioRendaVariavel>;
}

export interface IRelatorio<T> {
  nome: string;
  valores: T[];
}

export type RelatorioCustodia = {
  grupo?: string;
  codigo: string;
  localizacao: string;
  discriminacao: string;
  situacaoInicio: number;
  situacaoFim: number;
};

export type RelatorioDivida = {
  codigo: string;
  localizacao?: string;
  discriminacao: string;
  situacaoInicio: number;
  situacaoFim: number;
};

export type RelatorioRendimentos = {
  tipoDeRendimento: string;
  cnpj: string;
  razaoSocial: string;
  descricao: string;
  valor: number;
};

export type RelatorioRendaVariavel = {
  dataBase: Moment;
  resultado: {
    comum: {
      aVista: number;
      opcoes: number;
      dolar: number;
      indices: number;
      juros: number;
      outros: number;
      negativoAnterior: number;
      irrf: number;
    };
    daytrade: {
      aVista: number;
      opcoes: number;
      dolar: number;
      indices: number;
      juros: number;
      outros: number;
      negativoAnterior: number;
      irrf: number;
    };
    fii: {
      total: number;
      negativoAnterior: number;
      irrf: number;
    };
  };
};
